import { SOCIAL_AUTH_PROVIDERS } from '@unipile/db';
import { Static } from '@sinclair/typebox';
import { StringEnum } from '../utils/typebox';

export const SocialAuthProviderSchema = StringEnum([...SOCIAL_AUTH_PROVIDERS]);

export type SocialAuthProvider = Static<typeof SocialAuthProviderSchema>;

export const SocialAuthModeSchema = StringEnum(['login', 'register', 'connect']);

export type SocialAuthMode = Static<typeof SocialAuthModeSchema>;
